export const alarmSound = "/alarm.798a570.mp3";
export const pdfWorker = "/pdf.worker.daf3628.mjs";
export const atemschutzAlarmSound = "/eieruhr.66cef4e.mp3";
export const shapefileUrl = "/shapefile.ab7bf63.js";
export const resetPage = "/reset.e3e053a.html";

export const heroImages = [
  { type: "image/avif", src: "/hero.0b37a27.avif" },
  { type: "image/webp", src: "/hero.157f025.webp" },
];
